import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import { CtaAlertBlockViewModel } from './CtaAlertModule.types';
import CtaButton from '@/components/CtaButton/CtaButton.vue';
import ArrowSmall from '@/assets/icons/chevron-thin.svg?inline';
import { SegmentElement } from '@/plugins/utm/SegmentElement';

const CtaAlertModuleProps = Vue.extend({
    props: getComponentProps<CtaAlertBlockViewModel>({
        Title: 'We will be operating in Antarctica this season',
        Content: '<p>We will be operating in Antarctica this season. Please read our Antarctica FAQs for important information about traveling with us during the 2021-2022 season. Due to overwhelming demand, we are currently experiencing heavy call volume. For new bookings, Request a Reservation here.</p>',
        ButtonLinks : [
            {
                Action: 'Button',
                ButtonStyle: 2,
                Link: '#',
                Title: 'SELECT EXPEDITION',
            },
            {
                Action: 'Button',
                ButtonStyle: 2,
                Link: '#',
                Title: 'SELECT ITINERARY',
            },
        ],
        BackgroundColor: '#F5F7F8',
        IsCollapsed: false,
    }),
});

@Component({
    components: {
        CtaButton,
        ArrowSmall,
    },
})
export default class CtaAlertModule extends CtaAlertModuleProps {
    toggleOpen(isTitleClicked?: boolean) {
        const interaction_type = this.p.IsCollapsed ? 'expansion' : 'closure';
        this.p.IsCollapsed = !this.p.IsCollapsed;
        SegmentElement.sendEvent('moduleInteraction', {
            interaction_type,
            module_type_id: this.$attrs['data-segmentid'],
            module_type_name: this.$attrs.type,
            ...(isTitleClicked && { text: this.p.Title }),
        })
    }
}
